import types from "../types"

/* Create */
export default function release(engine, model, query) {
  return {
    type: types.involve,
    engine,
    model,
    query,
  }
}
